<div
  class="work-context-bar"
  [class.is-editing]="isEditing"
  [class.is-incomplete]="!isComplete"
  [class.is-compact]="compact"
>
  <div class="context-shell">
    <span class="context-badge" [title]="compact ? 'Working context' : null">
      <i class="pi pi-map-marker" aria-hidden="true"></i>
      <span class="context-badge-text">{{ compact ? 'Context' : 'Working context' }}</span>
    </span>

    <ng-container *ngIf="!isEditing; else editingTpl">
      <span class="context-value" [title]="summaryLabel">{{ summaryLabel }}</span>
      <button type="button" class="context-change-btn" (click)="openEditor()">
        <i class="pi pi-pencil" aria-hidden="true"></i>
        <span>Change</span>
      </button>
    </ng-container>

    <ng-template #editingTpl>
      <div class="context-inline-fields">
        <div class="context-field context-field--clinic">
          <p-dropdown
            inputId="work-context-clinic"
            [options]="clinicOptions"
            [(ngModel)]="draftClinicId"
            optionLabel="label"
            optionValue="value"
            placeholder="Clinic"
            styleClass="context-dropdown"
            panelStyleClass="context-dropdown-panel"
            appendTo="body"
            (onChange)="onDraftChange()"
          ></p-dropdown>
        </div>

        <div class="context-field context-field--doctor">
          <p-dropdown
            inputId="work-context-doctor"
            [options]="doctorOptions"
            [(ngModel)]="draftDoctorId"
            optionLabel="label"
            optionValue="value"
            placeholder="Doctor"
            styleClass="context-dropdown"
            panelStyleClass="context-dropdown-panel"
            appendTo="body"
            (onChange)="onDraftChange()"
          ></p-dropdown>
        </div>
      </div>

      <button
        type="button"
        class="context-close-btn"
        aria-label="Close context editor"
        (click)="closeEditor()"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </ng-template>
  </div>
</div>
